import React from "react";
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

function ModalNotifycation({ isContainer = false,open, title = "", handleCancel, handleOk = null, message }) {
	const { t } = useTranslation()
	return (<Modal
		title={title}
		visible={open}
		onCancel={handleCancel}
		className="modal-notifycation"
		centered
		getContainer={isContainer ? false : null}
		width={684}
		footer={
			<div className="foot-login">
				<Button onClick={handleOk ? handleOk : handleCancel} className="button-foot-modal">
					{t("modal.modal_login.ok")}
				</Button>
			</div>
		}
	>
		<div className="modal-notifycation-body">
			{message}
		</div>

	</Modal>);
}

export default ModalNotifycation;